import { clsx } from 'clsx';
import { MarketingHeroPill } from '@/components/marketing/v2/MarketingHeroPill';
import { usePricingMode, type BillingMode } from './PricingContext';

export default function PricingHeroToggleV2() {
  const { mode, setMode } = usePricingMode();

  const tab = (m: BillingMode, label: string, badge?: string) => (
    <button
      type="button"
      onClick={() => setMode(m)}
      aria-pressed={mode === m}
      className={clsx(
        'relative inline-flex items-center gap-2 px-5 py-2.5 font-marketing-display text-[14px] font-bold transition-all md:px-6 md:text-[15px] cursor-pointer',
        mode === m
          ? 'bg-lime-500 text-charcoal-800 shadow-neobrutal-3'
          : 'text-charcoal-600 hover:text-charcoal-900',
      )}
    >
      {label}
      {badge && (
        <span
          className={clsx(
            'border-2 border-charcoal-800 px-1.5 py-0.5 font-marketing-mono text-[10px] font-bold',
            'bg-charcoal-800 text-lime-400',
          )}
        >
          {badge}
        </span>
      )}
    </button>
  );

  return (
    <section className="bg-paper pb-10 pt-16 md:pb-14 md:pt-20">
      <div className="mx-auto max-w-5xl px-6 text-center md:px-8">
        <MarketingHeroPill className="mx-auto">5 plans · transparents</MarketingHeroPill>

        <h1 className="mt-7 font-marketing-display text-[clamp(48px,7vw,104px)] font-bold leading-[0.92] tracking-[-0.045em] text-charcoal-800">
          Un prix. <span className="underline-lime">Pas un piège.</span>
        </h1>

        <p className="mx-auto mt-7 max-w-2xl font-marketing-body text-lg leading-[1.55] text-charcoal-600 md:text-xl">
          Tu choisis selon ta taille réelle : nombre de boutiques, produits, employés, appareils et
          niveau d'accompagnement. Annulable à tout moment.
        </p>

        <div className="mt-10 inline-flex items-center gap-1 border-2 border-charcoal-800 bg-white p-1 shadow-neobrutal-4">
          {tab('monthly', 'Mensuel')}
          {tab('yearly', 'Annuel', '−17%')}
        </div>

        <p className="mt-4 font-marketing-mono text-[11px] font-medium uppercase tracking-[0.14em] text-charcoal-500">
          {mode === 'yearly'
            ? "Payé à l'année, tu économises 2 mois"
            : "Passe à l'annuel pour économiser 2 mois"}
        </p>
      </div>
    </section>
  );
}
